const sentryConfig = {
	dsn: 'https://2c518628a68f6628adc4fa621f043ec7@sentry.hellonimbly.com/4'
};

export {sentryConfig};
